module.exports = __webpack_public_path__ + "img/network_security-1920.106b22ca.jpg";